import {
  Component,
  ChangeDetectionStrategy,
  effect,
  inject,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CustomersFacadeService } from '../../services/customers/customers-facade.service';
import { SummaryCardData, SummaryData } from '../../shared/models/models';
import { CustomersData } from '../../shared/models/customers.model';
import { CardModalComponent } from '../../shared/components/card-modal/card-modal.component';
import { AuthService } from '../../core/auth.service';
import { SHARED_MATERIAL_IMPORTS, SHARED_COMPONENT_IMPORTS } from '../../shared/shared-imports';
import { MODAL_SITE_COLUMNS } from '../../../constants/constants';
import { IGridRowEventArgs, IgxGridModule } from '@infragistics/igniteui-angular';

@Component({
  standalone: true,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardModalComponent, IgxGridModule, ...SHARED_MATERIAL_IMPORTS, SHARED_COMPONENT_IMPORTS],
})
export class HomeComponent {
  public customersFacadeService = inject(CustomersFacadeService);
  private auth = inject(AuthService);
  public summary: SummaryCardData[] = [];
  public modalSiteColumns = MODAL_SITE_COLUMNS;
  public editionTitle = '';
  public editionLabel = '';
  public editionCustomers: CustomersData[] = [];

  @ViewChild('editionVenues') private editionVenuesTemplate!: TemplateRef<unknown>;

  private dialog = inject(MatDialog);
  private router = inject(Router);
  private snackBar = inject(MatSnackBar);
  private editionVenuesRef?: MatDialogRef<unknown>;

  public openEditionVenues(title: string, barData: SummaryData): void {
    const customers = barData.customers ?? [];
    if (!customers.length) return;

    this.editionTitle = title;
    this.editionLabel = barData.label;
    this.editionCustomers = customers;

    this.editionVenuesRef = this.dialog.open(this.editionVenuesTemplate, {
      maxWidth: '60vw',
      width: '60vw',
      maxHeight: '90vh',
    });
  }

  public closeEditionVenues(): void {
    this.editionVenuesRef?.close();
    this.editionVenuesRef = undefined;
  }

  public openVenueDetails(selectedRow: IGridRowEventArgs): void {
    const venue = (selectedRow?.row?.data ?? {}) as CustomersData;
    const systemId = (venue.systemId ?? '').toString().trim().toUpperCase();

    if (!systemId) {
      this.snackBar.open('No data available for this customer', 'Close', {
        duration: 1000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
      return;
    }

    this.closeEditionVenues();
    this.router.navigate(['/customers', systemId]);
  }

  constructor() {
    effect(() => {
      this.auth.refreshTrigger();
      this.customersFacadeService.loadCustomersTableData();
    });
  }
}
